// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"747":"84038a2c","922":"f2f91b65"}[chunkId] + ".css";
};